// extracted by mini-css-extract-plugin
export default {"tableWrap":"tableWrap--rzq8C"};